import { ItemStatus } from '../enums/ItemStatus';

export const isWIP = (statusId: number) => {
  if ([ItemStatus.Idea, ItemStatus.Concept_Review].includes(statusId))
    return true;
  if (statusId >= 50 && statusId < 800) return true;
  return false;
};

export const isPendingRepublishing = (statusId: number) =>
  statusId == ItemStatus.PendingRepublish;

export const isLightUpdate = (statusId: number) =>
  statusId >= 3000 && statusId < 4000;

export const isActiveDocument = (statusId: number) =>
  isWIP(statusId) || isPendingRepublishing(statusId) || isLightUpdate(statusId);

export const isPublished = (statusId: number) =>
  statusId == ItemStatus.Published ||
  statusId == ItemStatus.PublishedHistoricalNonCPP;

export const isPublishedOrCompletedInCPP = (statusId: number) =>
  statusId == ItemStatus.Published || statusId == ItemStatus.Complete;

export const isWIPProductionPhase = (statusId: number) =>
  (statusId >= ItemStatus.Outline && statusId < ItemStatus.Published) ||
  isLightUpdate(statusId) ||
  isPendingRepublishing(statusId);
